import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

import { map, take } from 'rxjs/operators';

export interface CompareIds {
  index: number;
  uuid: string;
}

export interface CompareState {
  compareMode: CompareIds[];
  compare: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ProjectCardStore {
  constructor(private readonly componentStore: ComponentStore<CompareState>) {
    this.initStore();
  }

  initStore() {
    this.componentStore.setState({ compareMode: [], compare: false });
  }

  private checkExists(state: CompareState, compareMode: CompareIds) {
    let index = -1;
    state.compareMode.filter((x: CompareIds) => {
      if (x.index === compareMode.index) {
        index = x.index;
      }
    });
    return index;
  }

  readonly selection$ = this.componentStore.select((state) => state);
  readonly getCompare$ = this.componentStore.select((state) => state.compare).pipe(take(1));

  getValues() {
    return this.componentStore
      .select((state) => state)
      .pipe(
        map((state) => {
          if (state.compareMode.length > 1) {
            const uuids = state.compareMode.map((x) => x.uuid);
            const index = state.compareMode.map((x) => x.index);
            return { uuids: uuids, index: index, compare: true };
          }
          return { uuids: [], index: [], compare: false };
        })
      );
  }

  resetSelection() {
    this.componentStore.setState({ compareMode: [], compare: false });
  }

  patchCompare(compare: boolean) {
    this.componentStore.patchState(() => ({
      compare: compare,
    }));
  }

  addSelection(compareMode: CompareIds) {
    this.componentStore.setState((state) => {
      if (this.checkExists(state, compareMode) >= 0) {
        const newState = state.compareMode.filter((x) => x.uuid);
        return {
          ...state,
          newState,
        };
      }
      return {
        ...state,
        compareMode: [...state.compareMode, compareMode],
      };
    });
  }
}
